export default __webpack_public_path__ + "static/media/Irrevocable.87df6d12.svg";